import { mountModule } from '@websky/core/src/__fsd__/shared/lib/mount-module';
import { enableSentry } from '@websky/core/src/utils';
import { Config, mergeConfig } from '@websky/core/src/context';
import { withConfig } from '@websky/core/src/config-hoc';
import { store } from '@websky/core/src/SearchForm/components/Component';
import { setLocation } from '@websky/core/src/SearchForm/store/segments/actions';

export const setIata = (iata: string, name: string, type: 'departure' | 'arrival') => {
	const MAX_TRIES = 20;
	let tryCount = 0;

	const interval = setInterval(() => {
		if (!store) {
			console.log('no store');
			tryCount += 1;

			return;
		}

		if (tryCount === MAX_TRIES) {
			clearInterval(interval);
		}

		clearInterval(interval);

		store.dispatch(
			setLocation(
				{
					iata: iata,
					name: name,
					stopPointsCount: null,
					match: {
						type: 'Default',
						iata: null,
						distance: null,
						name: null,
						__typename: 'LocationMatch'
					},
					__typename: 'LocationInLocationGroup'
				},
				type
			)
		);
	}, 100);
};

enableSentry();

import SearchForm from './SearchForm';
import { config as defaultConfig } from '../../config';

export const init = (mount: HTMLElement, config: Config): (() => void) => {
	const Component = withConfig(SearchForm, mergeConfig(defaultConfig, config));

	return mountModule(Component, mount);
};
